import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import BanHangApi from "service/QuanLyMuaBan/BanHangApi"; 
import { pushNotification } from "utils/notifications";

export const ModalXoaBanHang = ({ orderId, show, onHide, onSaved }) => {
    const [isSubmit, setIsSubmit] = useState(false);

    const handleDelete = () => {
        setIsSubmit(true);
        BanHangApi.xoaBanHang(orderId) 
            .then(res => {
                if (res.status === 200) {
                    pushNotification("Xóa đơn hàng thành công!", "success", "TOP_CENTER", 2000); 
                    onSaved(); 
                } else {
                    pushNotification(res.message || "Xóa đơn hàng thất bại!", "error", "TOP_CENTER", 2000); 
                }
            })
            .catch(error => {
                const errMsg = error.response?.data || error.message || "Đã xảy ra lỗi!";
                pushNotification(errMsg, "error", "TOP_CENTER", 2000);
            })
            .finally(() => {
                setIsSubmit(false);
                onHide(); 
            });
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" className="modal-new modal fade text-left">
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                    <span className="btn-icon-right"><img src="/app-assets/images/icon-xoa-v2.png" alt="icon" /></span>
                    Xác nhận xóa
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide} disabled={isSubmit}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form-body text-center">
                    <h5>Bạn có chắc chắn muốn xóa đơn hàng này không?</h5> 
                    <p>Tài sản sẽ được hoàn về kho, phiếu thu liên quan sẽ bị hủy.</p> 
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide} disabled={isSubmit}>
                    <span><i className="mdi mdi-close"></i></span>&nbsp; Hủy
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                    disabled={isSubmit}
                    style={{ borderRadius: '8px', padding: '10px 20px' }}
                >
                    <span><i className="mdi mdi-delete"></i></span>&nbsp; {isSubmit ? "Đang xóa..." : "Xóa"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalXoaBanHang;